import styled, { css } from "styled-components";

const semanticTokens = {
  size: {
    medium: {
      item: "3rem",
      icon: "1.6rem",
    },
  },
};

export const Wrap = styled.button`
  background: transparent;
  width: ${semanticTokens.size.medium.item};
  height: ${semanticTokens.size.medium.item};
  border-radius: 0.4rem;
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;

  ${({ theme }) => css`
    /* status: default */
    svg {
      color: ${theme.color.grey[400]};
      width: ${semanticTokens.size.medium.icon};
      height: ${semanticTokens.size.medium.icon};
    }

    /* status: hover */
    &:hover {
      svg {
        color: ${theme.color.text.secondary};
      }
    }

    /* status: disabled */
    &:disabled {
      cursor: not-allowed;

      svg {
        color: ${theme.color.grey[300]};
      }
    }
  `}
`;
